import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Briefcase, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import PublicLayout, { PageHero } from '../components/public/PublicLayout';
import { EASE, Reveal, Stagger, StaggerItem } from '../components/public/motion';

const ContactPage = () => {
  const inputClasses =
    'w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3.5 text-gray-900 transition-all duration-200 placeholder:text-gray-400 focus:border-transparent focus:bg-white focus:outline-none focus:ring-2 focus:ring-red-500';

  return (
    <PublicLayout>
      <PageHero
        eyebrow="Contact"
        title="Let's start a conversation"
        subtitle="Ready to start your journey with us? Whether you're hiring or looking for your next role, get in touch today."
      />

      <section className="bg-gray-50 py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-4 md:px-8">
          <Stagger className="space-y-5" gap={0.12}>
            {/* Primary — email */}
            <StaggerItem>
              <motion.a
                href="mailto:contact@appsytec.com"
                whileHover={{ x: 6 }}
                transition={{ duration: 0.25, ease: EASE }}
                className="flex items-center gap-5 rounded-3xl border border-gray-200 bg-white p-8 shadow-lg shadow-gray-900/5 transition-shadow hover:shadow-xl"
              >
                <div className="rounded-2xl bg-red-50 p-4 text-red-500 shrink-0">
                  <Mail className="h-7 w-7" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold uppercase tracking-widest text-red-500">Email us</p>
                  <p className="mt-1 font-display text-2xl font-bold text-gray-900 md:text-3xl break-all">
                    contact@appsytec.com
                  </p>
                  <p className="mt-1 text-gray-500">Click to open in your email client</p>
                </div>
                <ArrowRight className="ml-auto h-5 w-5 shrink-0 text-gray-400" />
              </motion.a>
            </StaggerItem>

            <StaggerItem>
              <motion.div
                whileHover={{ x: 6 }}
                transition={{ duration: 0.25, ease: EASE }}
                className="flex items-start gap-5 rounded-3xl border border-gray-200 bg-white p-8"
              >
                <div className="rounded-2xl bg-red-50 p-4 text-red-500 shrink-0">
                  <MapPin className="h-7 w-7" />
                </div>
                <div>
                  <p className="text-sm font-semibold uppercase tracking-widest text-red-500">Based in</p>
                  <p className="mt-1 font-display text-2xl font-bold text-gray-900">Melbourne, Australia</p>
                </div>
              </motion.div>
            </StaggerItem>

            <StaggerItem>
              <motion.div
                whileHover={{ x: 6 }}
                transition={{ duration: 0.25, ease: EASE }}
                className="flex items-start gap-5 rounded-3xl border border-gray-200 bg-white p-8"
              >
                <div className="rounded-2xl bg-red-50 p-4 text-red-500 shrink-0">
                  <Briefcase className="h-7 w-7" />
                </div>
                <div>
                  <p className="text-sm font-semibold uppercase tracking-widest text-red-500">Looking for a role?</p>
                  <Link
                    to="/jobs"
                    className="mt-1 inline-block font-display text-2xl font-bold text-gray-900 transition-colors hover:text-red-500"
                  >
                    Browse the job board →
                  </Link>
                </div>
              </motion.div>
            </StaggerItem>
          </Stagger>
        </div>
      </section>
    </PublicLayout>
  );
};

export default ContactPage;
